'use client';

import { Organisation } from '@/types/organisation';

interface OrganisationHeaderProps {
  organisation: Organisation;
}

export function OrganisationHeader({ organisation }: OrganisationHeaderProps) {
  return (
    <div className="bg-primary/5">
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center gap-4">
          {organisation.logoUrl && (
            <div className="w-12 h-12 rounded-lg overflow-hidden flex items-center justify-center">
              <img
                src={organisation.logoUrl}
                alt={organisation.name}
                className="w-full h-full object-contain"
              />
            </div>
          )}
          <div>
            <h1 className="text-2xl font-bold text-foreground">{organisation.name}</h1>
          </div>
        </div>
      </div>
    </div>
  );
}
